
/* injects from baggage-loader */
var Template = require('./template.js');
require('./style.scss');

import { Component } from "react";
import { getSwarmSubscriptionRequestGameListStandart } from "../../../helpers/terminalRequests/gameListStandart";
import { SwarmDataMixin, getSwarmDataKeyForRequest } from "../../../mixins/swarmDataMixin";
import { StandartGamesListUpdateReceived, ResetStandartGamesList } from "../../../actions/standartActions";
import { handleGameListStandartSubscriptionData } from "../../../helpers/standartHelpers";
import { connect } from "react-redux";
import moment from "moment";
import { createSelector } from "reselect";
import PropTypes from "prop-types";
import Helpers from "../../../helpers/helperFunctions";
import { getBoostedOdds } from "../../../helpers/terminalRequests/boostedOdds";
import { StandardGameListBoosted } from "../../../helpers/standardListHelper";
import { handleFavoriteGameListSubscriptionData } from "../../../helpers/asianHelpers";
function roundDate (timeStamp) {
    timeStamp -= timeStamp % (24 * 60 * 60 * 1000);//subtract amount of time since midnight
    timeStamp += new Date().getTimezoneOffset() * 60 * 1000;//add on the timezone offset
    return new Date(timeStamp);
}
class GameList extends Component {
    constructor (props) {
        super(props);
        this.scroll = this.scroll.bind(this);
        this.state = {
            gameLoadCount: 20
        };
        this.handleScrollListener = this.handleScrollListener.bind(this);
    }
    scroll (scrollSize) {
        return () => {
            let iterator = (scrollSize > 0 ? 0.1 : -0.1);
            this.delta = this.delta || iterator;
            this.delta += iterator;
            this.scrollGamesListStandart.scrollTop += (scrollSize + this.delta);
        };
    }
    handleScrollListener (e) {
        const { scrollHeight, clientHeight, scrollTop } = e.target;
        const { gameLoadCount } = this.state;
        const gameCounts = this.props.sportAlias === 'all' || this.props.sportAlias === "boosted" ? this.props.compNames.reduce((sum, current) => sum + current.data.reduce((sum, current) => sum + current[current.key].length, 0), 0)
            : this.props.compNames.reduce((sum, current) => sum + current[current.key].length, 0);
        if (scrollHeight - clientHeight - scrollTop < 30 && gameLoadCount < gameCounts) {
            this.setState({ gameLoadCount: gameLoadCount + 20 });
        }
    }

    componentDidUpdate () {
        if (this.props.compNames) {
            const scrollPos = JSON.parse(sessionStorage.getItem('scrollPos'));
            if (scrollPos && this.scrollGamesListStandart && history.state && scrollPos[history.state.key]) {
                this.scrollGamesListStandart.scrollTop = scrollPos[history.state.key];
            }
        }
    }

    render () {
        return Template.default.apply(this); //eslint-disable-line no-undef
    }
    componentWillUnmount () {
        this.props.dispatch(ResetStandartGamesList(this.props.selectorKey));
    }
}

GameList.propTypes = {
    selectorKey: PropTypes.string,
    compNames: PropTypes.object,
    sportAlias: PropTypes.string
};

const mapStateToProps = (_, ownParams) => {
    let { gameType, sportAlias, regionId, competitionId, timeFilter, boostedOddsGameIds } = ownParams,
        key;
    if (sportAlias === "boosted") {
        key = getSwarmDataKeyForRequest(getBoostedOdds(boostedOddsGameIds, gameType));
    } else {
        key = getSwarmDataKeyForRequest(getSwarmSubscriptionRequestGameListStandart(gameType, sportAlias, regionId, +competitionId, timeFilter));
    }
    return createSelector(
        [
            state => state.swarmData.loaded[key],
            state => state.standartGameList[key] && JSON.stringify((() => {
                let compNames = [];
                if (ownParams.sportAlias !== "boosted") {
                    Helpers.objectToArray(state.standartGameList[key]).sort((a, b) => a.competitionOrder - b.competitionOrder).forEach((game) => {
                        const index = compNames.findIndex(item => item.key === game.competitionName);
                        //let day = moment.unix(game.start_ts).day();
                        let localTimestamp = game.start_ts - new Date().getTimezoneOffset() * 60;
                        let day = moment.unix(roundDate(localTimestamp * 1000)).unix() / 1000;
                        if (~index) {
                            compNames[index][compNames[index].key].push({ gameid: game.id, start_ts: game.start_ts });
                            if (compNames[index].data[day]) {
                                compNames[index].data[day].push({ gameid: game.id, start_ts: game.start_ts });
                            } else {
                                compNames[index].data[day] = [{ gameid: game.id, start_ts: game.start_ts }];
                            }
                        } else {
                            compNames.push({
                                [game.competitionName]: [game.id],
                                regionAlias: game.regionAlias,
                                key: game.competitionName,
                                data: { [day]: [{ gameid: game.id, start_ts: game.start_ts }] }
                            });
                        }
                    });
                    return compNames;
                }
                return StandardGameListBoosted(state.standartGameList[key]);
            })())
        ],
        (loaded, compNames) => {
            return {
                loaded,
                selectorKey: key,
                compNames: compNames && JSON.parse(compNames)
            };
        });
};

export default connect(mapStateToProps)(SwarmDataMixin(
    {
        Component: GameList,
        ComponentWillMount: function () {
            let { gameType, sportAlias, regionId, competitionId, timeFilter, boostedOddsGameIds } = this.props;
            if (sportAlias === 'boosted') {
                this.swarmSubscriptionRequest = getBoostedOdds(boostedOddsGameIds, gameType);
                this.swarmDataKey = getSwarmDataKeyForRequest(getBoostedOdds(boostedOddsGameIds, gameType));
            } else {
                this.swarmSubscriptionRequest = getSwarmSubscriptionRequestGameListStandart(gameType, sportAlias, regionId, +competitionId, timeFilter);
                this.swarmDataKey = getSwarmDataKeyForRequest(getSwarmSubscriptionRequestGameListStandart(gameType, sportAlias, regionId, +competitionId, timeFilter));
            }
            this.meta = {
                simplify: true,
                preventOriginalAction: true,
                finalize: (loaded) => {
                    return {
                        additionalActions: [StandartGamesListUpdateReceived.bind(null, sportAlias === "boosted" && boostedOddsGameIds ? handleFavoriteGameListSubscriptionData(loaded) : handleGameListStandartSubscriptionData(loaded, { alias: sportAlias }))]
                    };
                }
            };
        }
    }
));